import { fromJS } from 'immutable'
import moment from 'moment'

export const notePaymentState = fromJS({
  id: 0,
  refno: '',
  bulk_code_id: 0,
  semcamp_id: 0,
  payee: '',
  paydate: moment(),
  remarks: '',
  updated_by: 0,
  student_id: 0,
  student_id_input: '',
  amount: 0,
  words: '',
  bulkcode_name: '',
  bulkcode_code: '',
  paydate_string: '',
  sy: '',
  sem: '',
  fees: [
      {
          id: 0,
          bulk_collection_id: 0,
          fee_id: 0,
          line: 0,
          amount: '',
          fee_code: '',
          fee_name: '',
          uacs: '',
          acct_code: '',
      }
  ],
})

const initialState = fromJS({
  searchResults: [],
  item: {},
  searching: false,
  pending: false
})

export default function notepayment(state = initialState, action) {
  switch (action.type) {
    case 'NOTE_REQ':
      return state.set('pending', true)

    case 'NOTE_Q_REQ':
      return state.set('searching', true)

    case 'NOTE_Q_SUCC':
      return state
        .set('searching', false)
        .set('searchResults', fromJS(action.payload || []))

    case 'NOTE_DEL_SUCC':
      return state
        .set('pending', false)
        .set('item', fromJS(action.payload || {}))

    case 'NOTE_SAVE_SUCC':
    case 'NOTE_GET_SUCC':
      return state
        .set('pending', false)
        .set('item', fromJS(action.payload).set('paydate', moment(action.payload.paydate)))

    case 'NOTIF_FAIL':
      return state
        .set('pending', false)
        .set('searching', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotePayments/reducer.js